import { render, staticRenderFns } from "./article-like-dislike-section.vue?vue&type=template&id=4acff9aa&"
import script from "./article-like-dislike-section.vue?vue&type=script&lang=js&"
export * from "./article-like-dislike-section.vue?vue&type=script&lang=js&"
import style0 from "./article-like-dislike-section.vue?vue&type=style&index=0&id=4acff9aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports